<template>
<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <SystemModulesForm v-if="systemModule" :systemModule="systemModule" />
    <LoadingPage v-if="!systemModule"/>
  </PageRowWrapper>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import SystemModulesForm from '@/components/settings/users/systemModules/SystemModulesForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'SystemModuleEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    SystemModulesForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      systemModule: state => state.systemModules.systemModuleById
    })
  },
  methods: {
    ...mapActions('systemModules', ['fetchById', 'cleanState'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
